import { CircularProgress, Stack, Typography, styled } from '@mui/material';
import { theme } from '~/shared/styles/theme';

const SponsorDashboardLoadingState = () => (
  <LoadingCenteredWrapper>
    <LoadingStack spacing={4}>
      <CircularProgress size={72} />
      <Stack spacing={1.5} alignItems="center">
        <LoadingPrimaryText>
          Calculating cohort statistics...
        </LoadingPrimaryText>
        <LoadingSecondaryText>
          Aggregating de-identified patient data
        </LoadingSecondaryText>
      </Stack>
    </LoadingStack>
  </LoadingCenteredWrapper>
);

export default SponsorDashboardLoadingState;

const LoadingCenteredWrapper = styled(Stack)(() => ({
  flex: 1,
  minHeight: `calc(100vh - ${theme.tokens.layout.headerHeight}px - ${theme.spacing(40)})`,
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
}));

const LoadingStack = styled(Stack)(() => ({
  alignItems: 'center',
  textAlign: 'center',
  gap: theme.spacing(4),
}));

const LoadingPrimaryText = styled(Typography)(() => ({
  fontSize: 22,
  fontWeight: 700,
  color: theme.palette.custom.darkBrown,
}));

const LoadingSecondaryText = styled(Typography)(() => ({
  fontSize: 18,
  color: theme.palette.custom.mediumBrown,
}));
